import { render, staticRenderFns } from "./MTab.vue?vue&type=template&id=d2cc3efc&scoped=true"
import script from "./MTab.vue?vue&type=script&lang=js"
export * from "./MTab.vue?vue&type=script&lang=js"
import style0 from "./MTab.vue?vue&type=style&index=0&id=d2cc3efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cc3efc",
  null
  
)

export default component.exports